import React, { useState } from "react";

const TIER_COLOR = {
  SVIP: "#73b85a",
  VIP:  "#c85f62",
  GOLD: "#e9cc73",
  SILV: "#2f4458",
  BRON: "#9a6f3a",
};

/**
 * COORDINATE SYSTEM: 1000 x 800
 * We use shared vertices to ensure no gaps or overlaps.
 */
const ZONES = [
  // --- ROW 1 (TOP) ---
  { id: "bron-l-1", label: "BRON", tier: "BRON", d: "M50 140 L160 100 L175 165 L70 205 Z", tx: 110, ty: 155, tr: -20 },
  { id: "silv-l-1", label: "SILV", tier: "SILV", d: "M160 100 L210 95 L220 175 L175 165 Z", tx: 190, ty: 135, tr: -10 },
  { id: "vip-l-1",  label: "VIP",  tier: "VIP",  d: "M210 95 L310 90 L315 178 L220 175 Z", tx: 265, ty: 135, tr: -5 },
  { id: "svip-l-1", label: "SVIP", tier: "SVIP", d: "M310 90 L425 85 L425 180 L315 178 Z", tx: 370, ty: 135, tr: -2 },
  { id: "svip-c-1", label: "SVIP", tier: "SVIP", d: "M435 85 L565 85 L565 180 Q500 195 435 180 Z", tx: 500, ty: 135, tr: 0 },
  { id: "svip-r-1", label: "SVIP", tier: "SVIP", d: "M575 85 L690 90 L685 178 L575 180 Z", tx: 630, ty: 135, tr: 2 },
  { id: "vip-r-1",  label: "VIP",  tier: "VIP",  d: "M690 90 L790 95 L780 175 L685 178 Z", tx: 735, ty: 135, tr: 5 },
  { id: "silv-r-1", label: "SILV", tier: "SILV", d: "M790 95 L840 100 L825 165 L780 175 Z", tx: 810, ty: 135, tr: 10 },
  { id: "bron-r-1", label: "BRON", tier: "BRON", d: "M840 100 L950 140 L930 205 L825 165 Z", tx: 890, ty: 155, tr: 20 },

  // --- ROW 2 (MIDDLE) ---
  { id: "br-l-2",   label: "BR",   tier: "BRON", d: "M45 220 L100 225 L100 340 L45 330 Z", tx: 72, ty: 280, tr: 0 },
  { id: "silv-l-2", label: "SILV", tier: "SILV", d: "M100 225 L180 235 L170 410 L100 340 Z", tx: 140, ty: 310, tr: 0 },
  { id: "vip-l-2",  label: "VIP",  tier: "VIP",  d: "M180 235 L380 240 L365 410 L170 410 Z", tx: 275, ty: 325, tr: 0 },
  { id: "svip-l-2", label: "SVIP", tier: "SVIP", d: "M350 280 L430 270 L430 350 L355 360 Z", tx: 392, ty: 315, tr: -5 },
  { id: "svip-c-2", label: "SVIP", tier: "SVIP", d: "M440 270 L560 270 L565 375 Q500 400 435 375 Z", tx: 500, ty: 325, tr: 0 },
  { id: "vip-ctr",  label: "VIP CTR", tier: "VIP", d: "M435 375 L565 375 L570 450 L430 450 Z", tx: 500, ty: 412, tr: 0 },
  { id: "svip-r-2", label: "SVIP", tier: "SVIP", d: "M570 270 L650 280 L645 360 L570 350 Z", tx: 608, ty: 315, tr: 5 },
  { id: "vip-r-2",  label: "VIP",  tier: "VIP",  d: "M620 240 L820 235 L830 410 L635 410 Z", tx: 725, ty: 325, tr: 0 },
  { id: "silv-r-2", label: "SILV", tier: "SILV", d: "M820 235 L900 225 L900 340 L830 410 Z", tx: 860, ty: 310, tr: 0 },
  { id: "br-r-2",   label: "BR",   tier: "BRON", d: "M900 225 L955 220 L955 330 L900 340 Z", tx: 928, ty: 280, tr: 0 },

  // --- ROW 3 (ORCHESTRA) ---
  { id: "silv-l-3", label: "SILV", tier: "SILV", d: "M40 480 Q200 500 360 505 L345 615 Q180 610 40 590 Z", tx: 150, ty: 550, tr: 0 },
  { id: "gold-l-3", label: "GOLD L", tier: "GOLD", d: "M220 520 L375 525 L365 590 L215 585 Z", tx: 295, ty: 557, tr: 0 },
  { id: "gold-c-3", label: "GOLD CTR", tier: "GOLD", d: "M385 525 L615 525 L618 640 Q500 665 382 640 Z", tx: 500, ty: 585, tr: 0 },
  { id: "gold-r-3", label: "GOLD RG", tier: "GOLD", d: "M625 525 L780 520 L785 585 L635 590 Z", tx: 705, ty: 557, tr: 0 },
  { id: "silv-r-3", label: "SILV", tier: "SILV", d: "M640 505 Q800 500 960 480 L960 590 Q820 610 655 615 Z", tx: 850, ty: 550, tr: 0 },

  // --- ROW 4 (REAR CURVE) ---
  { id: "bron-low-l", label: "BRON", tier: "BRON", d: "M75 640 L195 615 L205 630 L85 660 Z", tx: 140, ty: 635, tr: -12 },
  { id: "silv-low-l", label: "SILV", tier: "SILV", d: "M195 675 L420 645 L420 660 L200 690 Z", tx: 310, ty: 668, tr: -5 },
  { id: "silv-low-c", label: "SILV", tier: "SILV", d: "M430 665 L570 665 L570 685 L430 685 Z", tx: 500, ty: 675, tr: 0 },
  { id: "silv-low-r", label: "SILV", tier: "SILV", d: "M580 645 L805 675 L800 690 L580 660 Z", tx: 690, ty: 668, tr: 5 },
  { id: "bron-low-r", label: "BRON", tier: "BRON", d: "M805 615 L925 640 L915 660 L795 630 Z", tx: 865, ty: 635, tr: 12 },
];

export default function NewPortVenueMap() {
  const [selected, setSelected] = useState(new Set());

  const toggle = (id) => {
    setSelected(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  return (
    <div className="flex flex-col items-center bg-[#e0e0e0] p-6 min-h-screen font-sans">
      <div className="w-full max-w-4xl bg-white p-8 rounded-xl shadow-2xl">
        <h1 className="text-2xl md:text-[26px] font-black text-center mb-8 tracking-tight uppercase italic text-gray-800">
          NEWPORT PERFORMING ARTS THEATER
        </h1>

        <svg viewBox="0 0 1000 750" className="w-full h-auto drop-shadow-lg">
          {/* STAGE */}
          <rect x="340" y="20" width="320" height="40" fill="#888" rx="2" />
          <text x="500" y="50" textAnchor="middle" fill="white" className="text-sm font-bold tracking-widest">STAGE</text>

          {/* ZONES */}
          {ZONES.map((z) => {
            const isSelected = selected.has(z.id);
            return (
              <g key={z.id} className="cursor-pointer transition-all duration-200" onClick={() => toggle(z.id)}>
                <path
                  d={z.d}
                  fill={TIER_COLOR[z.tier]}
                  stroke={isSelected ? "white" : "rgba(0,0,0,0.1)"}
                  strokeWidth={isSelected ? 4 : 0.5}
                  className="hover:brightness-110"
                />
              <text
                x={z.tx}
                y={z.ty}
                textAnchor="middle"
                transform={z.tr ? `rotate(${z.tr}, ${z.tx}, ${z.ty})` : ""}
                fill="rgba(0,0,0,0.7)"
                className="select-none pointer-events-none font-black"
                style={{ fontSize: z.label.length > 5 ? "10px" : "12px" }}
              >
                {z.label}
              </text>
              </g>
            );
          })}

          {/* BOTTOM FLOOR INDICATORS */}
          <g transform="translate(280, 720)">
             {[0, 90, 180, 270, 360].map(x => (
               <rect key={x} x={x} y="0" width="70" height="12" fill="#bcbcbc" rx="2" />
             ))}
          </g>
        </svg>
        
        <div className="mt-8 flex justify-center gap-4">
          {Object.entries(TIER_COLOR).map(([tier, color]) => (
            <div key={tier} className="flex items-center gap-2">
              <div className="w-4 h-4 rounded" style={{ backgroundColor: color }} />
              <span className="text-[10px] font-bold text-gray-600">{tier}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}